import newCompaignReducer from "./reducers/newCompaignReducer";
import sidebarReducer from "./reducers/sidebarReducer";

const { configureStore } = require("@reduxjs/toolkit");


const store = configureStore({
    reducer : {
        sidebar : sidebarReducer ,
        newCompaign : newCompaignReducer
    }
})

export default store;